import React from 'react';
import { Box, Button, Center, Container, Text, TextInput } from '@mantine/core';

import { PRIVACY_POLICY_HREF, TERMS_OF_USE_HREF } from '@/constants';
import { PrivacyChoices } from '@/components/PrivacyChoices';

import useLogin from './useLogin';

const LoginPage: React.FC = () => {
  const { onSubmit, form } = useLogin();

  return (
    <Center w="100dvw" h="100dvh">
      <Box w="400px">
        <img alt="Fooda" src="/assets/images/logo.svg" />
        <Text fz="2rem">Welcome to</Text>
        <Text fz="2rem" lh="1" fw="bold">
          Fooda for Restaurants
        </Text>
        <form onSubmit={onSubmit}>
          <TextInput
            mt="sm"
            placeholder="Enter your login email"
            size="lg"
            label="Email"
            withAsterisk
            autoFocus
            autoComplete="username"
            {...form.getInputProps('email')}
          />
          <Button mt="md" size="lg" fullWidth type="submit">
            Continue
          </Button>
        </form>

        <Text mb="sm" mt="md">
          By logging in, you agree to the{' '}
          <a href={TERMS_OF_USE_HREF} rel="noopener noreferrer" target="_blank">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={PRIVACY_POLICY_HREF} rel="noopener noreferrer" target="_blank">
            Privacy Policy
          </a>
        </Text>
        <Container>
          <Center>
            <PrivacyChoices />
          </Center>
        </Container>
      </Box>
    </Center>
  );
};

export default LoginPage;
